const info = {
  ZH: { //中文翻译
    title: "\u96F6\u90E8\u4EF6",
    metarialtab: "\u6750\u6599\u6570\u636E\u8868",
    type: " \u7C7B\u578B",
    cid: " ID",
    cver: " \u7248\u672C",
    busness: "\u521B\u5EFA\u4F01\u4E1A",
    name: " \u96F6\u90E8\u4EF6\u540D\u79F0",
    nodenumber: "\u8282\u70B9\u6570\u91CF\u8BA1\u7B97",
    cfrname: " \u96F6\u90E8\u4EF6\u540D\u79F0(\u5916\u6587)",
    csymbol: "\u96F6\u90E8\u4EF6\u53F7",
    cmeaWeightFerItem: "\u6D4B\u91CF\u6240\u5F97\u5355\u4E2A\u8D28\u91CF\u503C",
    ccalWeightFerItem: " \u8BA1\u7B97\u6240\u5F97\u5355\u4E2A\u8D28\u91CF\u503C",
    cdeviation: "\u504F\u5DEE",
    ctolerance: "\u5141\u8BB8\u504F\u5DEE",
    ccalReuseRate: " \u8BA1\u7B97\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    cmeaReuseRate: " \u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    ccalRecycleRate: " \u8BA1\u7B97\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    keepsearch: "\u7EE7\u7EED\u67E5\u627E",
    cmeaRecycleRate: " \u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    remark: " \u5907\u6CE8",
    simpleCheckRule: " \u7B80\u5316\u6821\u9A8C\u89C4\u5219",
    create_date: " \u521B\u5EFA\u65E5\u671F",
    check_date: " \u68C0\u9A8C\u65E5\u671F",
    release_date: " \u53D1\u5E03\u65E5\u671F",
    num: "\u6570\u91CF",
    checkMDS: "校验",
    sample: " \u521d\u7248",
    componentType: "零部件类别",
    select: "\u9009\u62E9",
    overdue: "\u8FC7\u671F\u7684",
    deleted: "(已删除)",
    sampleChecked: '\u5982\u679C\u60A8\u52FE\u9009\u6B64\u9009\u9879\uFF0C\u5219\u6570\u636E\u4EC5\u80FD\u88AB\u6807\u8BB0\u4E3A\u201C\u521d\u7248\u201D\u7684\u8868\u5355\u5F15\u7528\u3002',
    saveTips: "\u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E\uFF0C\u60A8\u786E\u5B9A\u7EE7\u7EED\u64CD\u4F5C\u5417\uFF1F",
    saveMsg: "\u4FDD\u5B58\u5DF2\u6210\u529F\!",
    next: "\u4E0B\u4E00\u6B65",
    addComponent: "添加零部件",
    addSemicomponent: "添加半成品部件",
    addMetarial: "添加材料",
    addRefmdsData: "添加材料数据表或组件单元",
    addSubstance: "添加物质",
    use: '采用',
    internal: '\u5185\u90E8',
    transUnit: '\u8F6C\u6362\u7EC4\u4EF6',
    searchtree: '\u67E5\u627E\u6811',
    continueToSearch: "继续查找",
    createmdsrequest: '\u521B\u5EFA\u8BF7\u6C42',
    replacemds: '\u66FF\u6362\u4EF6',
    changemds: '\u7F6E\u6362',
    selectrequestmsg: '\u8BF7\u9009\u4E2D\u4E00\u4E2A\u8282\u70B9\!',
    backToResult: '\u67E5\u627E\u7ED3\u679C',
    save: '\u4FDD\u5B58',
    nextTips: '\u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E\uFF0C\u662F\u5426\u5148\u4FDD\u5B58\uFF0C\u7136\u540E\u8FDB\u5165\u4E0B\u4E00\u9875\u9762?',
    changeToMDS: "\u8F6C\u6362\u4E3A\u6750\u6599\u6570\u636E\u8868",
    multiSource: " \u8BBE\u7F6E\u4E3A\u591A\u6E90",
    firstChoice: " \u8BBE\u7F6E\u4E3A\u9996\u9009",
    firstChoiceMsg: " \u53EA\u5141\u8BB8\u5207\u6362 \u4E0D\u5141\u8BB8\u53D6\u6D88",
    multiSourceMsg: "\u5DF2\u6709\u4E00\u4E2A\u5F15\u7528\u7684MDS\u88AB\u8BBE\u5B9A\u4E3A\u201C\u9996\u9009\u201D\uFF0C\u5982\u679C\u52FE\u9009\u540E\uFF0C\u5C06\u53D8\u66F4\u5F53\u524D\u5F15\u7528MDS\u4E3A\u201C\u9996\u9009\u201D\uFF0C\u662F\u5426\u786E\u5B9A\u53D8\u66F4",
    cqcExportSaveMsg: "\u60A8\u8FD8\u6CA1\u6709\u4FDD\u5B58\u6570\u636E\uFF0C\u662F\u5426\u5148\u4FDD\u5B58\uFF0C\u7136\u540E\u8FDB\u5165\u4E0B\u4E00\u9875\u9762?",
    saveTips1: "请保存该MDS信息",
    cqcExport: 'EXCEL\u5bfc\u51fa',
    CICES:'CICES产品标识',
  },
  EN: { //英文翻译
    title: " Component",
    metarialtab: "MDS",
    type: " Type",
    cid: " ID",
    cver: " Version",
    busness: "Supplier",
    name: " Article Name",
    nodenumber: " The number of node",
    cfrname: "  Article Name(Foreign)",
    csymbol: "Component No.",
    cmeaWeightFerItem: " Measured Mass per Item",
    ccalWeightFerItem: " Calculated Mass per Item",
    cdeviation: "Deviation",
    ctolerance: "Tolerances",
    ccalReuseRate: " Calculated recyclability rate",
    cmeaReuseRate: " Measured recyclability rate",
    ccalRecycleRate: " Calculated recoverability rate",
    cmeaRecycleRate: " Measured recoverability rate",
    remark: " Remark",
    simpleCheckRule: " Simplified check rules",
    create_date: " Creation date",
    check_date: " Check date",
    release_date: " Release date",
    num: "Quantity",
    checkMDS: "Check",
    sample: "sample",
    componentType: "Component Type",
    select: 'Select',
    overdue: "Obsolete",
    deleted: "(Deleted)",
    sampleChecked: 'If you check this "sample" box, this MDS can only be referenced by the MDS that is also marked with "sample"',
    saveTips: "You have not saved your data yet,do you really want to proceed",
    saveMsg: "saved sucessfully",
    next: "Next",
    addComponent: "Add Component",
    addSemicomponent: "Add SemiComponent",
    addMetarial: "Add Metarial",
    addRefmdsData: "Add MDS or Module",
    addSubstance: "Add Substance",
    use: 'Apply',
    transUnit: 'To Module',
    internal: 'Internal',
    searchtree: 'Tree Search ',
    continueToSearch: "Continue To Search",
    createmdsrequest: 'Request',
    replacemds: 'Replacement',
    changemds:'Replace',
    selectrequestmsg: 'Please select one node\!',
    backToResult: 'Back to Result',
    save: 'Save',
    saveMsg: 'saved sucessfully',
    next: 'Next',
    nextTips: 'You have not saved your data yet , do you really want to save it and then jump to the next page?',
    changeToMDS: "changeToMDS",
    firstChoice: " Preferred MDS",
    multiSource: " Multi Sourced",
    firstChoiceMsg: " Only switch is allowed",
    multiSourceMsg: ' There is already a referenced MDS set as "preferred". If checked, the current referenced MDS will be changed to "preferred". Are you sure to change',
    cqcExportSaveMsg: "You have not saved your data yet , do you really want to save it and then jump to the next page?",
    saveTips1: "Please save this mds first!",
    cqcExport: "Cqc export",
    CICES:'CICES product identification',
  }
}
export default info //需要暴露出去
